createjs.MotionGuidePlugin.install();